import { collectArrayFromAttributes } from '../attributes'
import { SkipperLinkAttributes, SkipperLinkCorrelationFinderQuestion } from '../types'

export function skipperLinkCorrelationFinderAttributesFinalize(attributes: SkipperLinkAttributes) {
  attributes.questionType = 'cq'
  attributes.title ??= '(show correlation)'
  attributes.qtitle ??= 'Correlation finder'
  return attributes
}

export function skipperLinkAttributesToCorrelationFinderQuestion(
  attributes: SkipperLinkAttributes
): SkipperLinkCorrelationFinderQuestion {
  const question: SkipperLinkCorrelationFinderQuestion = {
    text: attributes.qtitle,
    type: 'dlc',
    variant: 'cf',
    mode: 'sigtest',
    batches: [
      {
        pattern: attributes['b-pattern'],
        position: 1,
        answerVariants: collectArrayFromAttributes(attributes, 'b', [
          'pattern'
        ]) as SkipperLinkCorrelationFinderQuestion['batches'][0]['answerVariants']
      },
      {
        pattern: attributes['a-pattern'],
        position: 2,
        answerVariants: collectArrayFromAttributes(attributes, 'a', [
          'pattern'
        ]) as SkipperLinkCorrelationFinderQuestion['batches'][0]['answerVariants']
      }
    ]
  }
  const finalizedQuestion = ensureCorrelationFinderQuestionIntegrity(question)
  if (finalizedQuestion) {
    return finalizedQuestion
  } else {
    // eslint-disable-next-line no-console
    console.error('Invalid question generated from link attributes', question)
    return null
  }
}

export function ensureCorrelationFinderQuestionIntegrity(
  question: SkipperLinkCorrelationFinderQuestion
): SkipperLinkCorrelationFinderQuestion {
  try {
    const traitsOptions = StatPage?.classes?.DataLab?.CorrelationFinder?.Lib?.traitsOptions || []
    const questionsOptions = StatPage?.classes?.DataLab?.CorrelationFinder?.Lib?.questionsOptions || []
    const ensureBatch = (batch: (typeof question.batches)[0]) => {
      // check if batch.answerVariants are a valid trait options
      const batchTraitOptions = traitsOptions.find(
        option => option.key.toLocaleLowerCase() === batch.pattern.toLocaleLowerCase()
      )
      if (batchTraitOptions) {
        batch.answerVariants = batch.answerVariants.filter(answerVariant =>
          batchTraitOptions.options.some(
            option => option.pattern.toLocaleLowerCase() === answerVariant.pattern.toLocaleLowerCase()
          )
        )
        return Boolean(batch.answerVariants.length)
      }

      // check if batch.answerVariants are a valid question options
      const batchQuestionOptions = questionsOptions.find(
        option => option.key.toLocaleLowerCase() === batch.pattern.toLocaleLowerCase()
      )
      if (batchQuestionOptions) {
        batch.answerVariants = batch.answerVariants.filter(answerVariant =>
          batchQuestionOptions.options.some(
            option => option.pattern.toLocaleLowerCase() === answerVariant.pattern.toLocaleLowerCase()
          )
        )
        return Boolean(batch.answerVariants.length)
      }

      return false
    }
    return ensureBatch(question.batches[0]) && ensureBatch(question.batches[1]) ? question : null
  } catch {
    return null
  }
}
